import {Observable} from "rxjs";
export function resizeObserver$(element: HTMLElement, options?: ResizeObserverOptions) {
	return new Observable<ResizeObserverEntry[]>((subscriber) => {
		const ro = new ResizeObserver((entries) => {
			subscriber.next(entries);
		});
		ro.observe(element, options);
		return () => {
			ro.unobserve(element);
			ro.disconnect();
		};
	});
}
